import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import Times from '@v2/context/Times/page';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';

interface PartDetailsNCFileTimesProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const PartDetailsNCFileTimesComponent: FC<PartDetailsNCFileTimesProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
  ncFileData,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Times
        withoutPaddingHorizontal
        ncFileId={ncFileData?.data?.ncFileId}
        style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
      />
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFileTimesComponent);

export { PartDetailsNCFileTimes };
